import { render, staticRenderFns } from "./BarChartVideoDuration.vue?vue&type=template&id=452bbca4&scoped=true&"
import script from "./BarChartVideoDuration.vue?vue&type=script&lang=js&"
export * from "./BarChartVideoDuration.vue?vue&type=script&lang=js&"
import style0 from "./BarChartVideoDuration.vue?vue&type=style&index=0&id=452bbca4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452bbca4",
  null
  
)

export default component.exports